import React from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field, getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard } from 'components'
import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { BLContainer } from './styled'

const RequestInformation = props => {
  const { members, valueForm } = props

  const setMember = () => {
    if (valueForm && valueForm.requesterUser) {
      let user = members.find(x => x.username.toLowerCase() === valueForm.requesterUser.toLowerCase())
      if (!user) {
        let result = members.map((m, i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
        result.push({
          key: `${lower(valueForm.requesterUser)}`,
          value: lower(valueForm.requesterUser),
          text: valueForm.requesterName
        })
        return result
      } else {
        return members.map((m, i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
      }
    } else {
      return []
    }
  }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title='Request Information :'>
          <BLContainer >
            <div className='rowFields'>
              <Field
                name='title'
                label='Title (Request for)'
                type={type.text}
                component={FieldInput}
                editable={false}
                tooltip
              />
              <Field
                name='requesterName'
                label='Requester'
                component={FieldInput}
                allowAdditions={false}
                loading={members.loading}
                options={setMember()}
                type={type.text}
                editable={false}
              />
            </div>
            <div className='rowFields'>
              <Field
                name='documentNumber'
                label='Document No.'
                type={type.text}
                editable={false}
                component={FieldInput}
              />
              <Field
                name='documentDate'
                label='Document Date'
                type={type.date}
                component={FieldInput}
                dateFormat='dd MMM yyyy HH:mm'
                editable={false}
              />
            </div>
            <div className='rowFields'>
              <Field
                name='companyCode'
                label='Company'
                type={type.select}
                allowAdditions={false}
                options={props.companies.data}
                loading={props.companies.loading}
                component={FieldInput}
                editable={false}
              />
              <Field
                name='submittedDate'
                label='Submitted Date'
                type={type.date}
                component={FieldInput}
                editable={false}
                dateFormat='dd MMM yyyy HH:mm'
              />
            </div>
            <div className='rowFields'>
              <div style={{ marginRight: '0.9375rem', flex: '1' }}></div>
              <Field
                name='modifiedDate'
                label='Modified Date'
                type={type.date}
                editable={false}
                dateFormat='dd MMM yyyy HH:mm'
                component={FieldInput}
              />
            </div>
          </BLContainer >
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = state => {
  return {
    members: state.member.members,
    companies: state.options.companies,
    valueForm: getFormValues('formBill')(state) || {}
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInformation)